module.exports = __webpack_public_path__ + "img/ch.dd37b131.png";